var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3542_11726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2709 16.1077C38.085 16.0034 37.8055 15.9714 37.5627 16.0269L10.0722 22.2733C9.83066 22.328 9.67029 22.4577 9.66309 22.604C9.65589 22.7495 9.80317 22.8843 10.0388 22.9468L19.2553 25.3814L26.9232 22.2211C27.225 22.0966 27.6026 22.3086 27.3807 22.478L21.7511 26.7825L26.0887 31.9567C26.1967 32.0856 26.4277 32.1672 26.681 32.1672C26.6869 32.1672 26.6935 32.1672 26.6994 32.1672C26.9592 32.1628 27.1903 32.0728 27.2878 31.9376L38.4149 16.5053C38.5138 16.3686 38.4568 16.2121 38.2709 16.1077Z",
    fill: "#161717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3542_11726",
    x: 5.66284,
    y: 16,
    width: 36.8,
    height: 24.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3542_11726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3542_11726",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSales);
export default __webpack_public_path__ + "static/media/new_sales.fb56a9d32f4912f4570e7032e5766cad.svg";
export { ForwardRef as ReactComponent };